import React from 'react';
import { Link } from 'react-router-dom';
import { TRACKS, getTrack, CourseImage } from './courseTracks';

// Shared "Included Courses" section — groups courses by track and links each to its course detail page.
const IncludedCoursesSection = ({ courses = [], programId, programName, bg = '#F8FAFF' }) => {
  if (courses.length === 0) return null;

  const grouped = {};
  courses.forEach((course) => {
    const track = getTrack(course.course_name);
    if (!grouped[track]) grouped[track] = [];
    grouped[track].push(course);
  });

  return (
    <section style={{ padding: '60px 5%', background: bg }}>
      <div style={{ maxWidth: 1200, margin: '0 auto' }}>
        <h2 style={{ fontSize: 26, fontWeight: 900, color: '#0F172A', margin: '0 0 6px', letterSpacing: '-0.02em', textAlign: 'center' }}>Included Courses</h2>
        <p style={{ fontSize: 14, lineHeight: 1.75, color: '#475569', margin: '0 0 36px', textAlign: 'center' }}>Browse courses by track — each track covers a focused skill domain</p>
        {TRACKS.filter((t) => grouped[t.name]?.length > 0).map((track) => (
          <div key={track.name} style={{ marginBottom: 48 }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: 12, marginBottom: 20, paddingBottom: 12, borderBottom: `2px solid ${track.border}` }}>
              <div style={{ width: 10, height: 10, borderRadius: '50%', background: track.accent, flexShrink: 0 }} />
              <h3 style={{ fontSize: 16, fontWeight: 800, color: track.accent, margin: 0, letterSpacing: '0.04em', textTransform: 'uppercase' }}>{track.name}</h3>
              <span style={{ fontSize: 12, fontWeight: 600, color: track.accent, background: track.bg, border: `1px solid ${track.border}`, borderRadius: 50, padding: '2px 10px' }}>
                {grouped[track.name].length} {grouped[track.name].length === 1 ? 'Course' : 'Courses'}
              </span>
            </div>
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill,minmax(260px,1fr))', gap: 18 }}>
              {grouped[track.name].map((course, i) => (
                <Link key={i} to={`/courses/${course.course_id}`} state={{ interestedProgram: programName, Program_id: programId }} style={{ textDecoration: 'none' }}>
                  <div
                    style={{ background: '#fff', border: `1.5px solid ${track.border}`, borderRadius: 12, overflow: 'hidden', cursor: 'pointer', transition: 'transform 0.2s, box-shadow 0.2s', boxShadow: '0 2px 8px rgba(0,0,0,0.05)', display: 'flex', flexDirection: 'column', height: '100%' }}
                    onMouseEnter={(e) => { e.currentTarget.style.transform = 'translateY(-4px)'; e.currentTarget.style.boxShadow = '0 8px 24px rgba(0,0,0,0.12)'; }}
                    onMouseLeave={(e) => { e.currentTarget.style.transform = 'none'; e.currentTarget.style.boxShadow = '0 2px 8px rgba(0,0,0,0.05)'; }}
                  >
                    <div style={{ height: 4, background: track.accent, flexShrink: 0 }} />
                    <CourseImage imgPath={course.img_Path} name={course.course_name} accent={track.accent} bg={track.bg} />
                    <div style={{ padding: '14px 16px 16px', flex: 1, display: 'flex', flexDirection: 'column', justifyContent: 'space-between' }}>
                      <h4 style={{ fontSize: 13.5, fontWeight: 700, color: '#0F172A', margin: '0 0 10px', lineHeight: 1.4 }}>{course.course_name}</h4>
                      <span style={{ fontSize: 11.5, fontWeight: 600, color: track.accent, background: track.bg, padding: '3px 10px', borderRadius: 50, border: `1px solid ${track.border}`, alignSelf: 'flex-start' }}>View Details →</span>
                    </div>
                  </div>
                </Link>
              ))}
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default IncludedCoursesSection;
